import {TenantsCommunityTotalDTO} from '@rsp/models/dto/tenants-community-totals.dto';
import {TenantsCommunityDatasDTO} from '@rsp/models/dto/tenants-community-data.dto';
import {CustomersEnergyUsagesDTO} from '@rsp/models/dto/customers-energy-usage.dto';
import {CustomersEnergyDatasDTO} from '@rsp/models/dto/customers-energy-data.dto';
import {RangeValueDTO} from '@rsp/models/dto/range-value.dto';

export class DTOHasDataValidator {

  public static validateRangeValueDTO(dto: RangeValueDTO<any>) {
    return dto !== undefined && dto.values.length > 0;
  }

  public static validateCommunityDataDTO(dto: TenantsCommunityDatasDTO): boolean {
    return this.validateRangeValueDTO(dto);
  }

  public static validateCommunityUsageDTO(dto: TenantsCommunityTotalDTO): boolean {
    return dto !== undefined;
  }

  public static validateCommunityUsagesDTO(dto: TenantsCommunityTotalDTO[]): boolean {
    return dto !== undefined && dto.length > 0 && dto.reduce((acc: boolean, cur) => {

      if (!this.validateCommunityUsageDTO(cur)) {
        acc = false;
      }
      return acc;
    }, true);
  }

  public static validateCustomerAutarkieDTO(dto: CustomersEnergyUsagesDTO): boolean {
    return this.validateRangeValueDTO(dto);
  }

  public static validateCustomerDataDTO(dto: CustomersEnergyDatasDTO): boolean {
    return this.validateRangeValueDTO(dto);
  }


}
